module.exports = __webpack_public_path__ + "static/img/dentaire-thumb.8610f4e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/dentaire-thumb.jpg
// module id = 32
// module chunks = 0